import { combineReducers } from '@reduxjs/toolkit'

import  currentCourseDetail  from './currentCourseDetailSlice'

const reducer = combineReducers({
    currentCourseDetail,
})

export default reducer
